uploadCsvCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'adminApi',
  'domain',
  'importRecord',
  'events'
]

export default function uploadCsvCtrl(
  $scope,
  $state,
  $stateParams,
  adminApi,
  domain,
  importRecord,
  events
) {
  var self = this
  self.uploading = false
  self.errorMessage = null
  self.importUuid = $stateParams.importUuid
  self.domainUuid = $stateParams.domainUuid
  self.importRecord = importRecord
  self.replaceAll = !!importRecord.replace_all
  self.provisionDefaultLicense = !!importRecord.provision_default_license
  self.logMessages = [
    {
      cssClass: 'text-muted',
      msg: 'Ready to upload'
    }
  ]
  function logI(msg) {
    self.logMessages.push({
      cssClass: 'text-info',
      msg: msg
    })
  }
  function logE(msg) {
    self.logMessages.push({
      cssClass: 'text-danger',
      msg: '[error] ' + msg
    })
  }
  function resetLog() {
    self.logMessages = [
      {
        cssClass: 'text-muted',
        msg: 'Ready to upload'
      }
    ]
  }

  if (domain.status === 'error') {
    self.errorMessage = domain.message
  } else {
    self.domainName = domain.name
    self.domainUsesSSOExternalId = domain.unique_id === 'sso_external_id' ? true : false
    $scope.$emit(events.DOMAIN_SELECTED, domain)
  }

  self.abort = function() {
    if (
      confirm(
        'Are you sure you want to cancel this import? You can resume it under "Incomplete Imports" on the dashboard.'
      )
    ) {
      $state.go('import-dashboard')
    }
  }

  self.onFileSelect = function($files) {
    self.file = $files[0]
  }

  self.upload = function() {
    self.uploading = true
    self.csvUploaded = false
    resetLog()
    logI('Uploading csv...')
    adminApi
      .uploadCSV($stateParams.importUuid, self.file, self.replaceAll, self.provisionDefaultLicense)
      .then(self.uploadCallback, self.uploadErrorCallback)
  }

  self.processUsers = function(csvData, domainUuid) {
    console.log(csvData)
    // validate that all users are in the domain for this import
    var sameDomain =
      domainUuid === self.domainUuid ||
      (self.domainUuid === 'CONSUMER-DOMAIN-UUID' && domainUuid === '')

    if (
      sameDomain ||
      confirm(
        'Selected users are not all in the same domain as the current import. Are you sure you want to continue?'
      )
    ) {
      self.uploading = true
      resetLog()
      logI('Uploading selected user data...')
      adminApi.uploadUserData($stateParams.importUuid, csvData, self.replaceAll, self.provisionDefaultLicense).then(self.uploadCallback)
    }
  }

  self.uploadCallback = function(uploadResponse) {
    console.log(uploadResponse)
    self.uploading = false
    $state.go('import-wizard.import-status', {
      domainUuid: self.domainUuid,
      importUuid: self.importUuid
    })
  }

  self.uploadErrorCallback = function(err) {
    logE(err)
  }
}
